module.exports = __webpack_public_path__ + "static/img/icon-refuse-2x.81e70eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/homepage/icon-refuse-2x.png
// module id = cqGn
// module chunks = 4